import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ViajeEADDto;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Folio", cell: x => ({ data: x.Folio }) },
    { title: "Status", cell: x => ({ data: models.StatusViajeEAD[x.Status] }) },
    { title: "Usuario capturó", cell: x => ({ data: x.NombreUsuario }) },
    { title: "Sucursal", cell: x => ({ data: x.NombreSucursal }) },
    { title: "Fecha creación", cell: x => ({ data: kea.toDate(x.FechaCreacion) }) },
    { title: "Fecha inicio", cell: x => ({ data: kea.toDate(x.FechaInicio) }) },
    { title: "Fecha llegada", cell: x => ({ data: kea.toDate(x.FechaLlegadaPendienteDescarga) }) },
    { title: "Fecha cancelación", cell: x => ({ data: x.FechaCancelacion }) },
    { title: "Ruta", cell: x => ({ data: x.NombreRuta }) },
    { title: "Chofer", cell: x => ({ data: x.NombreChofer }) },
    { title: "Camión", cell: x => ({ data: x.NombreCamion }) },
    { title: "Usuario App", cell: x => ({ data: x.NombreUsuarioApp }) },
];

export interface BotonesDeps {
    onDarLlegada: (x: Entity) => void;
    onDarSalida: (x: Entity) => void;
    onCancelar: (x: Entity) => void;
    onIniciarApp: (x: Entity) => void;
    onVer: (x:Entity) => void;

    onTimbrarCartaPorteEAD: (x: Entity) => void;
    onImprimirCartaPorteEAD: (x: Entity) => void;
    onMostrarListadoCartaPorteEAD: (x: Entity) => void;
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps,HabilitarValidacionesCartaPorte: boolean): Column[] {
    const botones = kea.columnaBotones([
        {
            iconClass: fa("mobile"),
            onClick: deps.onIniciarApp,
            tooltip: "Iniciar en móvil"
        }, {
            iconClass: fa("arrow-right"),
            onClick: deps.onDarSalida,
            tooltip: "Dar salida",
            disabled: x => HabilitarValidacionesCartaPorte ? !( x.TieneXmlCartaPorteTimbrado && x.TienexmlImpreso ) : false
        }, {
            iconClass: fa("times"),
            onClick: deps.onCancelar,
            tooltip: "Cancelar",
            //disabled: x => x.TieneXmlCartaPorteTimbrado,

        }, {
            iconClass: fa("eye"),
            onClick: deps.onVer,
            tooltip: "Ver"
        },{
            iconClass: fa("bell"),
            tooltip: "Timbrar Carta Porte",
            style: "default",
            onClick: deps.onTimbrarCartaPorteEAD,
            disabled: x => x.TieneXmlCartaPorteTimbrado,
        },{
            iconClass: fa("list"),
            tooltip: "verCartasTimbradas",
            style: "default",
            onClick: deps.onMostrarListadoCartaPorteEAD,
            disabled: x => !x.TieneXmlCartaPorteTimbrado,
        /*
        },{
            iconClass: fa("print"),
            tooltip: "Imprimir Carta Porte Timbrada",
            style: "default",
            onClick: deps.onImprimirCartaPorteEAD,
            disabled: x => !(x.TieneXmlCartaPorteTimbrado),
        */
        }
    ]);
    return [botones, ...columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajesEAD/list/columns.tsx